// types/tracking-params.ts
export const TRACKING_PARAMS = [
  'ads_rl',
  'dclid',
  'ds_agid',
  'fbclid',
  'gad_campaignid',
  'gad_source',
  'gbraid',
  'gclid',
  'gclsrc',
  'gcsrc',
  'gha2spon',
  'mc_cid',
  'mc_eid',
  'msclkid',
  'redirect',
  'sa',
  'ttclid',
  'ttq',
  'utm_campaign',
  'utm_campaignid',
  'utm_content',
  'utm_medium',
  'utm_source',
  'utm_source_platform',
  'utm_term',
  'ved',
] as const

export type TrackingParam = (typeof TRACKING_PARAMS)[number]
